// App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import SSORoute from './SSORoute';
import SSOLogin from './components/SSOLogin';
import SSOErrorPage from './components/SSOErrorPage';
import ChatbotUI from './components/ChatbotUI';
import './App.css';

function SSOKeyHandler() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const ssoKey = searchParams.get('key');

        if (ssoKey) {
            const storedSSOKey = localStorage.getItem('sso_key');
            if (!storedSSOKey || storedSSOKey !== ssoKey) {
                // 清除舊的認證資訊
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('role');
                localStorage.removeItem('username');
                localStorage.removeItem('token_expire');
                localStorage.removeItem('isSSO');

                // 儲存新的 sso_key 並導向 /sso-login
                localStorage.setItem('sso_key', ssoKey);
                navigate('/sso-login', { replace: true });
            }
        }
    }, [location.search, navigate]);

    return null;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <SSOKeyHandler />
                <Routes>
                    {/* SSO 用戶路由 */}
                    <Route path="/sso-login" element={<SSOLogin />} />
                    <Route path="/sso-chatbot" element={<SSORoute element={ChatbotUI} />} />
                    <Route path="/sso-error" element={<SSOErrorPage />} />
                    <Route path="/" element={<SSOLogin />} />
                    
                    {/* 404 或非預期外路徑 */}
                    <Route path="*" element={<SSOErrorPage />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
